





















































import { Component, Prop, Vue } from 'vue-property-decorator'
import VueDraggableResizable from 'vue-draggable-resizable'
import { GRID, DRAG_WIDTH, PADDING } from '@/components/numbers'
@Component<Drag>({
  components: {
    VueDraggableResizable
  }
})
export default class Drag extends Vue {
  @Prop()
  public width!: number
  @Prop()
  public height!: number
  @Prop()
  public x!: number
  @Prop()
  public y!: number
  @Prop()
  private onDragging!: (x: number, y: number) => void
  @Prop()
  private onDragStop!: () => void

  private dragging = false
  private DRAG_WIDTH = DRAG_WIDTH
  private GRID = GRID
  private OVERRAPPING = PADDING

  private onMove(x: number, y: number) {
    if (!this.dragging) {
      this.dragging = true
    }
    this.onDragging(x, y)
  }

  private onStop() {
    this.dragging = false
    this.onDragStop()
  }
}
